import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { FONT_SANS } from '../constants';
import { colors } from '../theme/colors';
import { useLanguage } from '../context/LanguageContext';

const Footer = styled.footer`
  padding: 48px clamp(20px, 5vw, 48px) 56px;
  background: ${colors.bg};
  border-top: 1px solid rgba(44, 42, 41, 0.06);
`;

const Inner = styled.div`
  max-width: 900px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  text-align: center;
`;

const Email = styled.a`
  font-family: ${FONT_SANS};
  font-size: 15px;
  font-weight: 600;
  color: ${colors.ink};
  text-decoration: none;

  &:hover {
    color: ${colors.accent};
  }
`;

const Nav = styled.nav`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;

  a {
    font-family: ${FONT_SANS};
    font-size: 14px;
    color: ${colors.inkMuted};
    text-decoration: none;

    &:hover {
      color: ${colors.ink};
    }
  }
`;

const Copy = styled.p`
  margin: 0;
  font-family: ${FONT_SANS};
  font-size: 13px;
  color: #94a3b8;
`;

function LandingFooter() {
  const year = new Date().getFullYear();
  const { t } = useLanguage();

  return (
    <Footer>
      <Inner>
        <Email href="mailto:support@onmyway.city">support@onmyway.city</Email>
        <Nav aria-label="Legal">
          <Link to="/about">{t.footer.about}</Link>
          <Link to="/support">{t.footer.support}</Link>
          <Link to="/privacy">{t.footer.privacy}</Link>
          <Link to="/terms">{t.footer.terms}</Link>
        </Nav>
        <Copy>{t.footer.copy.replace('{year}', String(year))}</Copy>
      </Inner>
    </Footer>
  );
}

export default LandingFooter;
